import React from 'react';

const SoftTissue = props => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="8"/>
    <path d="M12 8v8"/>
    <path d="M8 12h8"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

export default SoftTissue;
